import http from '../services/http';

export default class inviteService {
  constructor($http) {
    this.$http = $http;
  }

  queryCompanyCoupon(code) {
    return http.post('h5/coupon_company_query', {
      code,
    });
  }

  queryCommonCoupon(code) {
    return http.post('h5/coupon_common_query', {
      code,
    });
  }

  couponGrab(phoneNumber, code) {
    return http.post('h5/user_coupon_grab', {
      mobile_phone: phoneNumber,
      code,
    });
  }
}
